module.exports = __webpack_public_path__ + "img/Retail24.6d9f64f3.png";